export const HIDE_COMPANY_AND_ADD_BUTTON = 'hideCompanyAndAddButton'

export const HIDE_SEARCH_BUTTON = 'hideSearchButton'

export const HIDE_HELP_BUTTON = 'hideHelpButton'

export const HIDE_USER_MENU = 'hideUserMenu'

export const HEADER_MENU_EXPANDED_WIDTH_OFFSET = 280

export const HEADER_MENU_COLLAPSED_WIDTH_OFFSET = 0

export const MIN_WIDTH_FOR_HEADER_ELEMENTS = [
  {
    key: HIDE_COMPANY_AND_ADD_BUTTON,
    minAvailableWidth: 350,
  },
  {
    key: HIDE_SEARCH_BUTTON,
    minAvailableWidth: 300,
  },
  {
    key: HIDE_HELP_BUTTON,
    minAvailableWidth: 250,
  },
  {
    key: HIDE_USER_MENU,
    minAvailableWidth: 200,
  },
]
